export default __webpack_public_path__ + "static/media/icon-chat-record.cf204e2a.svg";